import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadListFileRowComponent } from './file-row.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileModule } from '@schoolbelle/api/file';
import { LetterWriteFileListFileNameTextModule } from '@schoolbelle/shared/components';
import { FileUploadListProgressBarModule } from '../progress-bar/progress-bar.module';
import { FileUploadListLogModule } from '../log/index';


@NgModule({
  declarations: [
    FileUploadListFileRowComponent,
  ],
  imports: [
    CommonModule,
    FileModule,
    FormsModule, ReactiveFormsModule,
    LetterWriteFileListFileNameTextModule,
    FileUploadListProgressBarModule, FileUploadListLogModule,
  ],
  exports:[FileUploadListFileRowComponent],
})
export class FileUploadListFileRowModule { }
